import { useMutation } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { Iteration, IterationDetailsFormValues } from 'schemas/Iteration.schema.ts';
import { UserInfo } from 'schemas/UserInfo.schema.ts';
import { apiFetch } from 'utils/apiUtils';

interface CreateIterationBody {
  iteration_details: Iteration,
  created_by: UserInfo,
  creation_timestamp: number,
  last_modified_by: UserInfo,
  last_modified_timestamp:number,
  locked_by: UserInfo,
  status: string,
}

interface CreateIterationVariables {
  teamId: string,
  campaignId: string,
  iteration: IterationDetailsFormValues,
}

export default function useCreateIteration() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId,
      campaignId,
      iteration,
    }: CreateIterationVariables) => apiFetch<CreateIterationBody>({
      path: `team/${teamId}/campaign/${campaignId}/iteration`,
      method: 'POST',
      accessToken: String(tokens.accessToken),
      body: iteration,
    }),
  });
}
